import * as ajax from './ajax';
import settingsConstants from '../constants/settingsConstants';
import tokenErrorActions from './tokenErrorActionCreators';
const loadSuccess = data => ({
  type: settingsConstants.SETTINGS_LOAD_SUCCESS,
  data
});
const loadFailure = data => ({
  type: settingsConstants.SETTINGS_LOAD_FAIL,
  data
});
const loading = () => ({
  type: settingsConstants.SETTINGS_LOADING
});
const serverLoad = () => async dispatch => {
  dispatch(loading());
  try {
    const response = await ajax.get('/lookup/CustomerSettings');
    return dispatch(loadSuccess(response.data));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'settings', loadFailure.bind(this, ajax.getError(e)), serverLoad.bind(this)));
  }
};
const refresh = () => (dispatch, getState) => {
  const {
    settings
  } = getState();
  if (!settings.loaded) {
    return dispatch(serverLoad());
  }
  return Promise.resolve();
};
const lookup = key => async (dispatch, getState) => {
  await dispatch(refresh());
  const {
    settings
  } = getState().settings;
  const {
    customStrings = {}
  } = settings;
  if (!customStrings) {
    return key;
  }
  return customStrings[key];
};
const actions = {
  serverLoad,
  lookup,
  refresh
};
export default actions;